import React from 'react';
import MultiLangSection from '../MultiLangSection';
import CustomizeSectionStep from './CustomizeSectionStep';
import { MULTI_LANG_CONTENT_TYPES } from '../Constants/values';
import { CustomizePageTabSection } from '../CustomizePageTabSection';

const CustomizeSection = ({ ecmContent, contentIndex }) => {
  if (ecmContent?.key === 'multiLanguageContainer') {
    return (
      <MultiLangSection
        ecmContent={ecmContent}
        forwardProps={{ contentIndex }}
        contentType={MULTI_LANG_CONTENT_TYPES.step}
      />
    );
  }
  if (ecmContent?.key === 'customizetabSection') {
    return <CustomizePageTabSection ecmContent={ecmContent} />;
  }
  return <CustomizeSectionStep ecmContent={ecmContent} contentIndex={contentIndex} />;
};

export default CustomizeSection;
